module.exports = __webpack_public_path__ + "img/ic-blokk.c4829a31.svg";